import { isObject } from "lodash";
import store from "../store";
import { SET_PREVIEW_CUSTODIAN, SET_PREVIEW_CUSTODIAN_SUCCESS } from "../store/custodian/actionTypes";

export const custodianPreview = (custodian) => {
  if (isObject(custodian)) {
    store.dispatch({
      type: SET_PREVIEW_CUSTODIAN_SUCCESS,
      payload: custodian,
    });
  } else {
    store.dispatch({
      type: SET_PREVIEW_CUSTODIAN,
      payload: custodian,
    });
  }
};